import { useMutation, useQuery } from "react-query";
import {
	checkClient,
	checkClientLocations,
	checkClientProducts,
	createClient,
	editClientLocation,
	editClientProduct,
	getAllClients,
	getClientById,
	getClientProducts,
	getClientLocations,
} from "../api-services/clients";

const clientProductKey = "client-products";
const clientsKey = "clients";
const clientKey = "client";

const useCreateClient = (mutationOptions = {}) => {
	const mutation = useMutation({
		mutationFn: (payload) => createClient(payload),
		onSuccess: (data) => {
			if (mutationOptions.onSuccess) {
				mutationOptions.onSuccess(data);
			}
		},
		onError: (error) => {
			if (mutationOptions.onError) {
				mutationOptions.onError(error);
			}
		},
	});

	return {
		createClient: mutation.mutate,
		isLoading: mutation.isPending,
		...mutation,
	};
};

const useCheckClient = (mutationOptions = {}) => {
	const mutation = useMutation({
		mutationFn: (payload) => checkClient(payload),
		onSuccess: (data) => {
			if (mutationOptions.onSuccess) {
				mutationOptions.onSuccess(data);
			}
		},
		onError: (error) => {
			if (mutationOptions.onError) {
				mutationOptions.onError(error);
			}
		},
	});

	return {
		checkClient: mutation.mutate,
		isLoading: mutation.isPending,
		...mutation,
	};
};

const useCheckClientProducts = (mutationOptions = {}) => {
	const mutation = useMutation({
		mutationFn: (payload) => checkClientProducts(payload),
		onSuccess: (data) => {
			if (mutationOptions.onSuccess) {
				mutationOptions.onSuccess(data);
			}
		},
		onError: (error) => {
			if (mutationOptions.onError) {
				mutationOptions.onError(error);
			}
		},
	});

	return {
		checkClientProducts: mutation.mutate,
		isLoading: mutation.isPending,
		...mutation,
	};
};

const useCheckClientLocations = (mutationOptions = {}) => {
	const mutation = useMutation({
		mutationFn: (payload) => checkClientLocations(payload),
		onSuccess: (data) => {
			if (mutationOptions.onSuccess) {
				mutationOptions.onSuccess(data);
			}
		},
		onError: (error) => {
			if (mutationOptions.onError) {
				mutationOptions.onError(error);
			}
		}
	});

	return {
		checkClientLocations: mutation.mutate,
		isLoading: mutation.isPending,
		...mutation,
	};
};

const useEditClientProduct = (mutationOptions = {}) => {
	const mutation = useMutation({
		mutationFn: (payload) => editClientProduct(payload),
		onSuccess: (data) => {
			if (mutationOptions.onSuccess) {
				mutationOptions.onSuccess(data);
			}
		},
		onError: (error) => {
			if (mutationOptions.onError) {
				mutationOptions.onError(error);
			}
		},
	});

	return {
		editClientProduct: mutation.mutate,
		isLoading: mutation.isPending,
		...mutation,
	};
};

const useEditClientLocation = (mutationOptions = {}) => {
	const mutation = useMutation({
		mutationFn: (payload) => editClientLocation(payload),
		onSuccess: (data) => {
			if (mutationOptions.onSuccess) {
				mutationOptions.onSuccess(data);
			}
		},
		onError: (error) => {
			if (mutationOptions.onError) {
				mutationOptions.onError(error);
			}
		},
	});

	return {
		editClientLocation: mutation.mutate,
		isLoading: mutation.isPending,
		...mutation,
	};
};

const useGetClientProducts = (clientId, options = {}) => {
	return useQuery({
		queryKey: [clientProductKey, clientId],
		queryFn: () => getClientProducts(clientId),
		enabled: !!clientId,
		...options,
	});
};

const useGetClientLocations = (clientId, options = {}) => {
	return useQuery({
		queryKey: [clientProductKey, clientId],
		queryFn: () => getClientLocations(clientId),
		enabled: !!clientId,
		...options,
	});
};

const useGetAllClients = (params = {}, options = {}) => {
	return useQuery({
		queryKey: [clientsKey, params],
		queryFn: () => getAllClients(params),
		...options,
	});
};

const useGetClientById = (clientId, options = {}) => {
	return useQuery({
		queryKey: [clientKey, clientId],
		queryFn: () => getClientById(clientId),
		enabled: !!clientId,
		...options,
	});
};

export {
	useCreateClient,
	useCheckClient,
	useCheckClientProducts,
	useCheckClientLocations,
	useEditClientProduct,
	useEditClientLocation,
	useGetClientProducts,
	useGetClientLocations,
	useGetAllClients,
	useGetClientById,
};